import { Add, Remove } from "@ellaandil/ui";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

type QuantityStepperButtonProps = {
	label: string;
	icon: React.ComponentType<{ className?: string }>;
	onClick?: () => void;
};

function QuantityStepperButton({ label, icon: Icon, onClick }: QuantityStepperButtonProps) {
	return (
		<button
			type="button"
			aria-label={label}
			onClick={onClick}
			className="inline-flex items-center justify-center size-5 shrink-0 rounded-component-specific-button bg-transparent border border-transparent text-text-dark-text-1 hover:text-text-dark-text-2 transition-colors duration-200 cursor-pointer"
		>
			<Icon className="size-3.5" />
		</button>
	);
}

type QuantityProps = {
	value: number;
	onDecrement?: () => void;
	onIncrement?: () => void;
	minusLabel?: string;
	plusLabel?: string;
	className?: string;
};

export const Quantity = forwardRef<HTMLDivElement, QuantityProps>(
	(
		{
			value,
			onDecrement,
			onIncrement,
			minusLabel = "Decrease quantity",
			plusLabel = "Increase quantity",
			className,
		},
		ref,
	) => {
		return (
			<div
				ref={ref}
				className={twMerge(
					"inline-flex items-center justify-center gap-grid-component-spacing-2xs rounded-component-specific-button shrink-0",
					className,
				)}
			>
				<QuantityStepperButton label={minusLabel} icon={Remove} onClick={onDecrement} />
				<span className="font-body font-regular text-xs leading-[1.15] text-text-dark-text-1 text-center uppercase tabular-nums lining-nums min-w-1.5">
					{value}
				</span>
				<QuantityStepperButton label={plusLabel} icon={Add} onClick={onIncrement} />
			</div>
		);
	},
);

Quantity.displayName = "Quantity";
